import { HisJobHandle } from './his-job-handle';

export class HisJobStatus {
    handle: HisJobHandle; // used to identify the jobExecution

    jobKey: string;
    jobName: string;

    status: string; // JobStatusEnum (QUEUED, RUNNING, PAUSED, ABORTED, FINISHED_SUCCESSFULLY, FINISHED_WITH_ERROR
    statusMsgKey: string; // I18n-Schlüssel der Statusmeldung

    startedAt: string | Date;
    finishedAt: string | Date;

    notificationLogId: number; // job protocol

    documentMetadataId: number; // job result if present
    resultDocumentUrl: string; // download-URL for Job result, if present

    /* Progress */
    numTotalItems: number;
    numSuccessfulItems: number;
    numFailedItems: number;

}
